import PortalModal from "@/components/PortalModal";
import close from "@/assets/icons/close.png";
import Image from "next/image";
import { getTranslation } from "@/utils/location";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/store";
import ActionButton from "@/components/ActionButton";
import { clearDailyReward } from "@/store/dailyReward/dailyRewardSlice";
import { sendWsEvent } from "@/utils/ws";
import { WebSocketsClientEvents } from "@/constants/events";
import { ModalRewardsContainer } from "@/components/Containers/ModalRewardsContainer";

import styles from "../../styles.module.scss";

const DailyRewardLayout = () => {
  const dispatch = useDispatch();
  const ws = useSelector((state: RootState) => state.sockets.ws);
  const { rewards } = useSelector((state: RootState) => state.dailyReward);
  const handleClose = () => {
    sendWsEvent(ws, WebSocketsClientEvents.COLLECT_DAILY_REWARD, {
      is_collected: false,
    });
    dispatch(clearDailyReward());
  };

  const handleCollect = () => {
    sendWsEvent(ws, WebSocketsClientEvents.COLLECT_DAILY_REWARD, {
      is_collected: true,
    });
    dispatch(clearDailyReward());
  };

  return (
    <PortalModal isOpen={Boolean(rewards)}>
      <div className={styles.modal}>
        <Image
          onClick={handleClose}
          className={styles.modal__close}
          src={close}
          alt="close"
        />
        <h1 className={`${styles.modal__title__up}`}>
          {getTranslation("ЕЖЕДНЕВНАЯ НАГРАДА")}
        </h1>
        <div className={styles.modal__content}>
          <ModalRewardsContainer rewards={rewards} className={styles.mt_25} />
          <div className={styles.modal__wrapper__text}>
            <span className={`${styles.modal__description} ${styles.mt_25} ${styles.w_80}`}>
              {getTranslation("Если вы пропустите один день, то потеряете прогресс")}
            </span>
          </div>
          <div className={`${styles.modal__actions} ${styles.mt_25}`}>
            <ActionButton className={styles.modal__actions_small} onClick={handleCollect}>
              {getTranslation("Забрать")}
            </ActionButton>
          </div>
        </div>
      </div>
    </PortalModal>
  );
};

export default DailyRewardLayout;
